import React from 'react';
import { useTheme } from 'styled-components';
import { DARK_THEME } from '@rsos/theme/constants';
import {
  RebrandedCompactLogo,
  RebrandedRapidSOSLogo,
  RebrandedUniteLogo,
} from './RebrandedLogos';

const useIsDarkMode = () => {
  const theme = useTheme();
  return theme?.colors?.name === DARK_THEME;
};

export const FullLogo = ({ showUniteLogo = false, height }) => {
  const isDarkMode = useIsDarkMode();

  return showUniteLogo ? (
    <RebrandedUniteLogo isDarkMode={isDarkMode} height={height} />
  ) : (
    <RebrandedRapidSOSLogo isDarkMode={isDarkMode} height={height} />
  );
};

export const RapidSOSLogoCompact = () => {
  const isDarkMode = useIsDarkMode();

  return <RebrandedCompactLogo isDarkMode={isDarkMode} />;
};
